.page-grid__row {
  --grid-cols: 12;

  display: flex;
  flex-wrap: wrap;
  min-width: 100%;
}

.page-grid__row-mt-0 {
  margin-top: 0;
}

.page-grid__row-mt-025 {
  margin-top: 0.25rem;
}

.page-grid__row-mt-050 {
  margin-top: 0.5rem;
}

.page-grid__row-mt-075 {
  margin-top: 0.75rem;
}

.page-grid__row-mt-100 {
  margin-top: 1rem;
}

.page-grid__row-mt-125 {
  margin-top: 1.25rem;
}

.page-grid__row-mt-150 {
  margin-top: 1.5rem;
}

.page-grid__row-mt-175 {
  margin-top: 1.75rem;
}

.page-grid__row-mt-200 {
  margin-top: 2rem;
}

.page-grid__row-mt-250 {
  margin-top: 2.5rem;
}

.page-grid__row-mt-300 {
  margin-top: 3rem;
}

.page-grid__row-mt-350 {
  margin-top: 3.5rem;
}

.page-grid__row-mb-0 {
  margin-bottom: 0;
}

.page-grid__row-mb-025 {
  margin-bottom: 0.25rem;
}

.page-grid__row-mb-050 {
  margin-bottom: 0.5rem;
}

.page-grid__row-mb-075 {
  margin-bottom: 0.75rem;
}

.page-grid__row-mb-100 {
  margin-bottom: 1rem;
}

.page-grid__row-mb-125 {
  margin-bottom: 1.25rem;
}

.page-grid__row-mb-150 {
  margin-bottom: 1.5rem;
}

.page-grid__row-mb-175 {
  margin-bottom: 1.75rem;
}

.page-grid__row-mb-200 {
  margin-bottom: 2rem;
}

.page-grid__row-mb-250 {
  margin-bottom: 2.5rem;
}

.page-grid__row-mb-300 {
  margin-bottom: 3rem;
}

.page-grid__row-mb-350 {
  margin-bottom: 3.5rem;
}

[class^="page-grid__col"] {
  position: relative;
}

.page-grid__col-12,
.page-grid__col {
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-1 {
  --collspan: 1;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-2 {
  --collspan: 2;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-3 {
  --collspan: 3;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-4 {
  --collspan: 4;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-5 {
  --collspan: 5;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-6 {
  --collspan: 6;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-7 {
  --collspan: 7;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-8 {
  --collspan: 8;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-9 {
  --collspan: 9;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-10 {
  --collspan: 10;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-11 {
  --collspan: 11;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

.page-grid__col-12 {
  --collspan: 12;

  flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
  max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
  padding: 0 calc(var(--grid-gap) / 2);
}

/* Medium 1024px */

@media only screen and (max-width: 64rem) {
  .page-grid__col-md-1 {
    --collspan: 1;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-2 {
    --collspan: 2;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-3 {
    --collspan: 3;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-4 {
    --collspan: 4;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-5 {
    --collspan: 5;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-6 {
    --collspan: 6;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-7 {
    --collspan: 7;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-8 {
    --collspan: 8;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-9 {
    --collspan: 9;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-10 {
    --collspan: 10;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-11 {
    --collspan: 11;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }

  .page-grid__col-md-12 {
    --collspan: 12;

    flex-basis: calc((var(--collspan) / var(--grid-cols) * 100%));
    max-width: calc((var(--collspan) / var(--grid-cols) * 100%));
    padding: 0 calc(var(--grid-gap) / 2);
  }
}

.page-grid__col-start-position-1 {
  margin-left: calc((1 / 12 * 100%));
}

.page-grid__col-start-position-2 {
  margin-left: calc((2 / 12 * 100%));
}

.page-grid__col-start-position-3 {
  margin-left: calc((3 / 12 * 100%));
}

.page-grid__col-start-position-4 {
  margin-left: calc((4 / 12 * 100%));
}

.page-grid__col-start-position-5 {
  margin-left: calc((5 / 12 * 100%));
}

.page-grid__col-start-position-6 {
  margin-left: calc((6 / 12 * 100%));
}

.page-grid__col-start-position-7 {
  margin-left: calc((7 / 12 * 100%));
}

.page-grid__col-start-position-8 {
  margin-left: calc((8 / 12 * 100%));
}

.page-grid__col-start-position-9 {
  margin-left: calc((9 / 12 * 100%));
}

.page-grid__col-start-position-10 {
  margin-left: calc((10 / 12 * 100%));
}

.page-grid__col-start-position-11 {
  margin-left: calc((11 / 12 * 100%));
}

/* Medium 1024px */

@media only screen and (max-width: 64rem) {
  .page-grid__col-md-start-position-1 {
    margin-left: calc((1 / 12 * 100%));
  }

  .page-grid__col-md-start-position-2 {
    margin-left: calc((2 / 12 * 100%));
  }

  .page-grid__col-md-start-position-3 {
    margin-left: calc((3 / 12 * 100%));
  }

  .page-grid__col-md-start-position-4 {
    margin-left: calc((4 / 12 * 100%));
  }

  .page-grid__col-md-start-position-5 {
    margin-left: calc((5 / 12 * 100%));
  }

  .page-grid__col-md-start-position-6 {
    margin-left: calc((6 / 12 * 100%));
  }

  .page-grid__col-md-start-position-7 {
    margin-left: calc((7 / 12 * 100%));
  }

  .page-grid__col-md-start-position-8 {
    margin-left: calc((8 / 12 * 100%));
  }

  .page-grid__col-md-start-position-9 {
    margin-left: calc((9 / 12 * 100%));
  }

  .page-grid__col-md-start-position-10 {
    margin-left: calc((10 / 12 * 100%));
  }

  .page-grid__col-md-start-position-11 {
    margin-left: calc((11 / 12 * 100%));
  }
}

/* Small 640px */

@media only screen and (max-width: 40rem) {
  .page-grid__col-1,
  .page-grid__col-2,
  .page-grid__col-3,
  .page-grid__col-4,
  .page-grid__col-5,
  .page-grid__col-6,
  .page-grid__col-7,
  .page-grid__col-8,
  .page-grid__col-9,
  .page-grid__col-10,
  .page-grid__col-11 {
    flex-basis: 100%;
    margin-left: 0;
    max-width: 100%;
  }
}
